import { useRef, useCallback } from 'react';
import { saveGridColumnState } from '../gridUtilities';

export const useColumnState = (gridApiRef, userData) => {
  const isColumnMoved = useRef(false);

  const onColumnMoved = useCallback(() => {
    isColumnMoved.current = true;
  }, []);

  const onDragStopped = useCallback(() => {
    if (gridApiRef.current && isColumnMoved.current) {
      const updatedConfig = saveGridColumnState({
        gridName: gridApiRef.current.gridName,
        columns: gridApiRef.current.getAllGridColumns(),
        userColumnPref: userData.userProfile?.columnPref,
        userId: userData.userProfile.userId
      });
      userData.updateUserProfile({
        columnPref: updatedConfig
      });
    }
    isColumnMoved.current = false;
  }, [userData]);

  return {
    onColumnMoved,
    onDragStopped
  };
}; 